import React from 'react';

import { DishPicture } from '../DishPicture';
import { DishTitle } from '../DishTitile';
import { AddToBasketButtonUI } from '../AddToBasketButtonUI';

import styles from './dish-card-upsell.scss';


export function DishCardUpsellDesktop(props) {
    const {
        imageUrl,
        imageUrlDesktop,
        price,
        strongTitle,
        title,
        handleAddToBasket,
        isDishInBasket,
    } = props;

    return (
        <div className={styles['dish-card-upsell__root']}>
            <div className={styles['dish-card-upsell__image']}>
                <DishPicture
                    alt={title[0]}
                    useLazyLoading
                    imageUrl={imageUrl}
                    imageUrlDesktop={imageUrlDesktop}
                />
            </div>
            <div className={styles['dish-card-upsell__content']}>
                <div className={styles['dish-card-upsell__title']}>
                    <DishTitle
                        strongTitle={strongTitle}
                        title={title}
                        layout="upsell"
                        joinDishTitlesinMobile
                    />
                </div>
                {handleAddToBasket && (
                    <div className={styles['dish-card-upsell__button']}>
                        <AddToBasketButtonUI
                            handleAddToBasket={handleAddToBasket}
                            isDishInBasket={isDishInBasket}
                            buttonsDisabled={false}
                            hasDiscount={false}
                            price={price}
                            originalPriceWithStep={String(price)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
